import React, { useEffect } from "react";

export default function Ad (props) {
	const { dataAdSlot } = props;


	useEffect (() => {
		try {
			/*const scriptElement = document.querySelector (
				'script[src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7145998361279144"]'
			);
			const handleScriptLoad = () => {
				if (window.adsbygoogle) {
					console.log ('pushing ads');
					window.adsbygoogle.push ({});
				}
				else {
					scriptElement.addEventListener ("load", handleScriptLoad);
					console.log ("waiting untill adsense lib is loaded");
				}
			};
			handleScriptLoad ();

			return () => {
				if (scriptElement)
					scriptElement.removeEventListener ("load", handleScriptLoad);
			};*/
			(window.adsbygoogle = window.adsbygoogle || []).push ({});
		} catch (e) {
			console.log (e);
		}
	},[]);

	return (
		<div style={{backgroundColor: '', marginTop: '20px'}}>
			<ins className="adsbygoogle"
				style={{ display: "block" }}
				data-ad-client="ca-pub-7145998361279144"
				data-ad-slot={dataAdSlot}
				data-ad-format="auto"
				data-full-width-responsive="true">
			</ins>
		</div>
	);
}
